import { AuthGuard } from 'components/auth'
import { PermissionEnum } from 'api/userPermissions'
import { EditMemberMain } from './components/EditMemberMain'
import { EditMemberProvider } from './context/EditMemberProvider'

interface Props {
  memberId: number
  onClose: () => void
}

export function EditMember({ memberId, onClose }: Props) {
  return (
    <AuthGuard.Permission value={PermissionEnum.ManageRoles}>
      <EditMemberProvider memberId={memberId}>
        <EditMemberMain onClose={onClose} />
      </EditMemberProvider>
    </AuthGuard.Permission>
  )
}
